(() => {
  const root = document.querySelector(".luma-home");

  if (!root) {
    return;
  }

  const revealElements = [...root.querySelectorAll(".luma-reveal")];
  const protectedPreviews = [...root.querySelectorAll(".luma-protected")];
  const heroStage = root.querySelector(".luma-hero__stage");

  const reveal = () => {
    revealElements.forEach((element) => element.classList.add("is-visible"));
  };

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18 }
    );

    revealElements.forEach((element) => observer.observe(element));
  } else {
    reveal();
  }

  protectedPreviews.forEach((preview) => {
    preview.setAttribute("draggable", "false");
    preview.addEventListener("contextmenu", (event) => event.preventDefault());
    preview.addEventListener("dragstart", (event) => event.preventDefault());
  });

  document.addEventListener("contextmenu", (event) => {
    if (event.target.closest(".luma-protected")) {
      event.preventDefault();
    }
  });

  window.addEventListener(
    "scroll",
    () => {
      if (!heroStage || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }

      const progress = Math.min(window.scrollY / 800, 1);
      heroStage.style.transform = `translateY(${progress * 22}px)`;
    },
    { passive: true }
  );
})();
